<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-3 col-lg-3">
                <span class="navbar-brand">{{ $root.siteName }}</span>
                <p class="text-gray-700 mb-2">Marketing automation</p>
                <div v-if="$state.footerCreds.length" class="text-gray-700" style="font-size: 10px">
                    <div v-for="line in $state.footerCreds" :key="line">{{ line }}</div>
                </div>
            </div>
            <div v-for="(column, i) in columns" :key="i" class="col-6 col-md-3 col-lg-3">
                <ul class="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0" :class="{ 'mb-0': i === columns.length - 1 }">
                    <li class="mb-3" v-for="link in column" :key="link.url">
                        <router-link v-if="isInternal(link.url)" :to="link.url" class="text-reset">
                            {{ link.label }}
                        </router-link>
                        <a v-else :href="link.url" class="text-reset" :target="isExternalHttp(link.url) ? '_blank' : undefined">
                            {{ link.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            columns: [],
        }
    },
    created() {
        this.$services.SiteFooter().get().then(resp => {
            this.columns = resp.body.columns || []
        })
    },
    methods: {
        isInternal(url) {
            // /help/* deliberately uses plain <a> so clicks do a full-page
            // reload to nginx → SSR (SPA wiki routes were dropped).
            return url.startsWith('/') && !url.startsWith('/help')
        },
        isExternalHttp(url) {
            return url.startsWith('http')
        },
    },
}
</script>
